import { createRootRouteWithContext, createRouter, Navigate, Outlet } from "@tanstack/react-router";

import validation from "core/validation";
import { getContext } from "ui/Query";

import ErrorBoundary from "ui/ErrorBoundary";

import account from "areas/account/routes";
import auth from "areas/auth/routes";
import campaigns from "areas/campaigns/routes";
import home from "areas/home/routes";
import partners from "areas/partners/routes";
import pay from "areas/pay/routes";
import unlock from "areas/unlock/routes";

import api from "api";


export const root = createRootRouteWithContext()({
	component: () => <Outlet />
});

export const tree = root.addChildren([account, auth, campaigns, home, partners, pay, unlock]);

const router = createRouter({
	routeTree: tree,
	context: {
		...getContext()
	},
	defaultPreload: "intent",
	scrollRestoration: true,
	defaultStructuralSharing: true,
	defaultPreloadStaleTime: 0,
	defaultErrorComponent: ErrorBoundary,
	defaultOnCatch: (e, stack) => {
		const error = validation.serializeError(e);
		if (!error.type) api.error.log({ name: error.name, message: error.message, stack: stack.componentStack });
		return error;
	},
	defaultNotFoundComponent: () => <Navigate to="/" />
});

export default router;